import { Language, Highlight } from 'prism-react-renderer'
import theme from '../styles/prism-react-renderer-theme'
import React from 'react'

// from https://github.com/christoferolaison/nextjs-mdx-prism/blob/master/src/pages/_app.js
export default function CodeBlock({
  code,
  className,
}: {
  code: string
  className?: string
}): JSX.Element {
  const language = (className?.replace(/language-/, '') as Language) || 'jsx'
  return (
    <Highlight theme={theme} code={code.trim()} language={language}>
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <pre
          className={`overflow-scroll rounded-12 p-6 spacer-xs ${
            className || ''
          }`}
          style={{ ...style }}
        >
          {tokens.map((line, i) => (
            <div key={i} {...getLineProps({ line, key: i })}>
              {line.map((token, key) => (
                <span key={key} {...getTokenProps({ token, key })} />
              ))}
            </div>
          ))}
        </pre>
      )}
    </Highlight>
  )
}
